var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"font-bold",class:_vm.classNames,attrs:{"href":"javascript:;"},on:{"click":_vm.onClick}},[(_vm.title)?_c('span',{staticClass:"pr-2"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.showIcon)?_c('i',{staticClass:"el-icon-right h4"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }